import ticketService from 'modules/emergencies/ticketService';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const useFilterViewForm = ({ onSubmit = () => {} }) => {
  const [showErrors, setShowErrors] = useState(false);
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});
  let history = useHistory();

  const beforeOnSubmit = () => {
    return (values) => {
      //   clean backend errors
      setBackendErrors({});
      // waiting for backend
      setIsWaitingForResponse(true);
      //   trasnform the values we get from form to the format expected in backend
      const formValues = ticketService.utils.deepCopy(values);
      const filtersJSON = {
        assigned_to: formValues.assigned_to,
        shipper_id: formValues.shipper_id,
        vehicle_type: formValues.vehicle_type,
        working_area_id: formValues.working_area_id,
      };
      const filters = JSON.stringify(filtersJSON);

      const dto = { name: formValues.name, filters };
      onSubmit({ filterViewDto: dto })
        //   if submit works, form does nothing
        .then(() => {})
        // if submit fails, form saves the error
        // the original submit could also do something after errors
        .catch((e) => {
          //   the backend will return an error body with json format
          try {
            e.response.json().then((errorBody) => {
              console.error('🔥 ~ errorBody:', errorBody);
              setBackendErrors(errorBody);
              setIsWaitingForResponse(false);
            });
          } catch (eee) {
            // if the backend error is not a json, is empty or something unexpected
            // we treat that as a different errors
            setBackendErrors({
              details: 'can_not_reach_backend',
            });
            setIsWaitingForResponse(false);
          }
        });
    };
  };

  const goBack = () => {
    history.push('/emergencies/filter-views');
  };

  return {
    showErrors,
    setShowErrors,
    isWaitingForResponse,
    setIsWaitingForResponse,
    backendErrors,
    setBackendErrors,
    beforeOnSubmit,
    goBack,
  };
};

export default useFilterViewForm;
